import React, { Fragment, useState } from 'react';
import { Button, Form, FloatingLabel, Row, Col, Container } from 'react-bootstrap';
import RHService from '../../../../../../services/rh-auth';
import { Link } from 'react-router-dom';
import '../../../../../../styles/diario.scss';



const FormBusca = (props) => {
    const [nome, setNome] = useState("");
    const [empresa, setEmpresa] = useState("");

    const busca = async (query) => {
        if (query == "") {
            await props.fetchTerceirizados()
            setNome("")
        } else {
            var response = await RHService.buscarTerceirizados(query)
            if (response.data.length >= 1) {
                props.setTerceirizados(response.data)
                props.setVazio(false)
                setNome("")
            } else {
                props.setVazio(true)
                setNome("")
            }
        }
    }

    const preparaQuery = async () => {
        let prepQuery = "";
        if (nome) prepQuery = prepQuery + `&nome=${encodeURI(nome)}`;
        if (empresa !== "false" && empresa != "false" && empresa !== "") prepQuery = prepQuery + `&empresa=${encodeURI(empresa)}`;
        return prepQuery;
    }

    const handleKeyDown = async (e) => {
        e.preventDefault();
        let finalQuery = await preparaQuery();
        await busca(finalQuery)
    }

    return (
        <Fragment>
            <Container>
                <div className="da-espaco">
                    <Row xs={1} lg={2}>
                    <Col xs={12} lg={5}>
                            <Form.Group className="mb-3" controlId="nome">
                                <FloatingLabel
                                    label="Funcionário"
                                    className="mb-3"
                                >
                                    <Form.Control
                                        required
                                        type="text"
                                        name="nome"
                                        value={nome}
                                        onChange={e => setNome(e.target.value)} />
                                </FloatingLabel>
                            </Form.Group>
                        </Col>
                        <Col lg={5}>
                            <Form.Group className="mb-3" controlId="locais">
                                <FloatingLabel
                                    label="Empresa"
                                    className="mb-3"
                                >
                                    <Form.Select
                                        required
                                        aria-label="empresa"
                                        name="empresa"
                                        onChange={e => setEmpresa(e.target.value)}
                                    >
                                        <option>TODAS</option>
                                        {props.empresas
                                            .map((terc) => (
                                                <option key={terc._id} value={terc.empresa}>
                                                    {terc.empresa}
                                                </option>
                                            ))}
                                    </Form.Select>
                                </FloatingLabel>
                            </Form.Group>
                        </Col>
                        <Col xs={12} lg={1}>
                            <Button onClick={async (e) => handleKeyDown(e)} type='button' variant='primary'>Buscar</Button>
                        </Col>
                        <Col xs={12} lg={1}>
                            <Link to='/restrito/rh/terceirizado'>
                                <Button type='button' variant='danger'>Voltar</Button>
                            </Link>
                        </Col>
                    </Row>
                </div>
            </Container>
        </Fragment>
    )
}

export default FormBusca
